export default "__VITE_ASSET__WnXtvbnJ__"